import { render, staticRenderFns } from "./sidebar.component.html?vue&type=template&id=616134e7&scoped=true&"
import script from "./sidebar.component.ts?vue&type=script&lang=ts&"
export * from "./sidebar.component.ts?vue&type=script&lang=ts&"
import style0 from "./sidebar.component.scss?vue&type=style&index=0&id=616134e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616134e7",
  null
  
)

export default component.exports